<template>
<div class="card-display">
	<div class="row">
		<div class="title col-sm-6">
			<span>{{ this.$t(`app.sites.attributes.${title}`)}}</span>
		</div>
		<div class="value col-sm-6">
			<span>{{value ? value : this.$t(`app.partners.missing`)}}</span>
		</div>
	</div>
</div>
</template>

<script>
export default {
  name: 'CardDisplay',
  components: {
  },
  props: {
    title: {
      Type: String,
      required: true,
    },
    value: {
      Type: String,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  },
};
</script>

<style lang="scss">
.card-display {
	// border-bottom: 1px solid #F1F1F3;
	.title {
		font-size: 18px;
		font-weight: 500;
	}

	.value {
		font-size: 15px !important;
		color: #43425D;
		opacity: 0.5;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/CardDisplay.vue